import React, { createContext, useState, useContext } from "react";
import {
  NotificationModal,
  ConfirmModal,
} from "@cakrawalajakarta/shared-components";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    isOpen: false,
    type: "success",
    message: "",
  });
  const [confirm, setConfirm] = useState({
    isOpen: false,
    message: "",
    onConfirm: null,
    confirmButtonText: "Delete",
    cancelButtonText: "Cancel",
  });

  const showNotification = (type, message) => {
    setNotification({ isOpen: true, type, message });
  };

  const closeNotification = () => {
    setNotification({ isOpen: false, type: "success", message: "" });
  };

  const showConfirm = (
    message,
    onConfirm,
    confirmButtonText = "Delete",
    cancelButtonText = "Cancel"
  ) => {
    setConfirm({
      isOpen: true,
      message,
      onConfirm,
      confirmButtonText,
      cancelButtonText,
    });
  };

  const closeConfirm = () => {
    setConfirm({
      isOpen: false,
      message: "",
      onConfirm: null,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    });
  };

  const handleConfirm = () => {
    if (confirm.onConfirm) confirm.onConfirm();
    closeConfirm();
  };

  return (
    <NotificationContext.Provider
      value={{ showNotification, closeNotification, showConfirm, closeConfirm }}
    >
      {children}
      <NotificationModal
        isOpen={notification.isOpen}
        onClose={closeNotification}
        type={notification.type}
        message={notification.message}
      />
      <ConfirmModal
        isOpen={confirm.isOpen}
        onClose={closeConfirm}
        onConfirm={handleConfirm}
        message={confirm.message}
        confirmButtonText={confirm.confirmButtonText}
        cancelButtonText={confirm.cancelButtonText}
      />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
